import { AbilityConfig } from './types';

export const ABILITY_CONFIG: AbilityConfig = {
  OrganizationNotifications: {
    view: {
      groups: ['organizationManagement.notifications.read'],
      flags: ['ui__page-modules--notifications'],
    },
    update: {
      groups: ['organizationManagement.notifications.write'],
      flags: ['ui__page-modules--notifications'],
    },
  },
  OrganizationWebHooks: {
    view: {
      groups: ['organizationManagement.notifications.read'],
    },
    create: {
      groups: ['organizationManagement.notifications.create'],
    },
    update: {
      groups: ['organizationManagement.notifications.write'],
    },
    delete: {
      groups: ['organizationManagement.notifications.delete'],
    },
  },
  OrganizationSsoConnections: {
    view: {
      groups: ['organizationManagement.sso.read'],
    },
    create: {
      groups: ['organizationManagement.sso.create'],
    },
    update: {
      groups: ['organizationManagement.sso.write'],
    },
    delete: {
      groups: ['organizationManagement.sso.delete'],
    },
  },
  OrganizationBillingReport: {
    view: {
      groups: ['organizationManagement.billing.read'],
      flags: ['ui__page-modules--billing-report'],
    },
  },
  OrganizationDiscounts: {
    view: {
      groups: ['inventoryManagement.discounts.read'],
      flags: ['ui__page-modules--organization__discounts'],
    },
    create: {
      groups: ['inventoryManagement.discounts.create'],
      flags: ['ui__page-modules--organization__discounts'],
    },
    update: {
      groups: ['inventoryManagement.discounts.write'],
      flags: ['ui__page-modules--organization__discounts'],
    },
    delete: {
      groups: ['inventoryManagement.discounts.delete'],
      flags: ['ui__page-modules--organization__discounts'],
    },
  },
  OrganizationCommitments: {
    view: {
      groups: ['inventoryManagement.commitments.read'],
      flags: ['ui__page-modules--organization__commitments'],
    },
    update: {
      groups: ['inventoryManagement.commitments.write'],
      flags: ['ui__page-modules--organization__commitments'],
    },
    delete: {
      groups: ['inventoryManagement.commitments.delete'],
      flags: ['ui__page-modules--organization__commitments'],
    },
  },
  OrganizationClusterHibernate: {
    view: {
      groups: ['clusterOptimization.hibernationSchedules.read'],
      flags: ['ui__page-modules--organization__cluster-hibernate'],
    },
    create: {
      groups: ['clusterOptimization.hibernationSchedules.create'],
      flags: ['ui__page-modules--organization__cluster-hibernate'],
    },
    update: {
      groups: ['clusterOptimization.hibernationSchedules.write'],
      flags: ['ui__page-modules--organization__cluster-hibernate'],
    },
    delete: {
      groups: ['clusterOptimization.hibernationSchedules.delete'],
      flags: ['ui__page-modules--organization__cluster-hibernate'],
    },
  },
  OrganizationRebalanceSchedules: {
    view: {
      groups: ['clusterOptimization.rebalancing.read'],
      flags: ['ui__page-modules--organization__scheduled-rebalancing'],
    },
    create: {
      groups: ['clusterOptimization.rebalancing.create'],
      flags: ['ui__page-modules--organization__scheduled-rebalancing'],
    },
    update: {
      groups: ['clusterOptimization.rebalancing.write'],
      flags: ['ui__page-modules--organization__scheduled-rebalancing'],
    },
    delete: {
      groups: ['clusterOptimization.rebalancing.delete'],
      flags: ['ui__page-modules--organization__scheduled-rebalancing'],
    },
  },
  OrganizationCostMonitoring: {
    view: {
      groups: [
        'costMonitoring.clusters.read',
        'costMonitoring.workloads.read',
        'costMonitoring.allocationGroups.read',
      ],
      flags: ['ui__page-modules--organization__cost-monitoring'],
    },
    create: {
      groups: ['costMonitoring.allocationGroups.create'],
      flags: ['ui__page-modules--organization__cost-monitoring'],
    },
    update: {
      groups: ['costMonitoring.allocationGroups.write'],
      flags: ['ui__page-modules--organization__cost-monitoring'],
    },
    delete: {
      groups: ['costMonitoring.allocationGroups.delete'],
      flags: ['ui__page-modules--organization__cost-monitoring'],
    },
  },
  OrganizationCostMonitoringNodeTemplates: {
    view: {
      groups: ['costMonitoring.nodeConfigurations.read'],
      flags: [
        'ui__page-modules--organization__cost-monitoring__node-templates',
      ],
    },
  },
  ValueReport: {
    view: {
      flags: ['ui__page-modules--value-report'],
    },
  },
  OrganizationSecurityCompliance: {
    view: {
      groups: ['kubernetesSecurity.compliance.read'],
      flags: ['ui__page-modules--organization-security__best-practices'],
    },
    create: {
      groups: [
        'kubernetesSecurity.compliance.write',
        'kubernetesSecurity.compliance.read',
        'kubernetesSecurity.integrations.write',
        'kubernetesSecurity.integrations.read',
      ],
      flags: ['ui__page-modules--organization-security__best-practices'],
    },
  },
  OrganizationSecurityVulnerabilities: {
    view: {
      groups: [
        'kubernetesSecurity.components.read',
        'kubernetesSecurity.vulnerabilities.read',
      ],
      flags: ['ui__page-modules--organization-security__image-security'],
    },
    create: {
      groups: [
        'kubernetesSecurity.integrations.read',
        'kubernetesSecurity.integrations.write',
        'kubernetesSecurity.vulnerabilities.read',
      ],
      flags: ['ui__page-modules--organization-security__image-security'],
    },
    delete: {
      groups: ['kubernetesSecurity.vulnerabilities.delete'],
      flags: ['ui__page-modules--organization-security__image-security'],
    },
  },
  OrganizationSecurityAttackPaths: {
    view: {
      groups: [
        'kubernetesSecurity.components.read',
        'kubernetesSecurity.attackPaths.read',
        'kubernetesSecurity.vulnerabilities.read',
      ],
      flags: ['ui__page-modules--organization-security__attack-path'],
    },
    create: {
      groups: [
        'kubernetesSecurity.integrations.read',
        'kubernetesSecurity.integrations.write',
      ],
      flags: ['ui__page-modules--organization-security__attack-path'],
    },
  },
  OrganizationSecurityRuntime: {
    view: {
      groups: [
        'kubernetesSecurity.components.read',
        'kubernetesSecurity.runtime.read',
      ],
      flags: ['ui__page-modules--organization-security__anomalies'],
    },
    create: {
      groups: [
        'kubernetesSecurity.runtime.write',
        'kubernetesSecurity.runtime.create',
        'kubernetesSecurity.runtime.read',
      ],
      flags: ['ui__page-modules--organization-security__anomalies'],
    },
    update: {
      groups: [
        'kubernetesSecurity.runtime.write',
        'kubernetesSecurity.runtime.create',
        'kubernetesSecurity.runtime.read',
      ],
      flags: ['ui__page-modules--organization-security__anomalies'],
    },
    delete: {
      groups: ['kubernetesSecurity.runtime.delete'],
      flags: ['ui__page-modules--organization-security__anomalies'],
    },
  },
  OrganizationSecuritySettings: {
    view: {
      groups: [
        'kubernetesSecurity.settings.read',
        'kubernetesSecurity.components.read',
      ],
      flags: ['ui__page-modules--organization-security__settings'],
    },
    update: {
      groups: ['kubernetesSecurity.settings.write'],
      flags: ['ui__page-modules--organization-security__settings'],
    },
  },
  OrganizationSecurityIntegrations: {
    view: {
      groups: [
        'kubernetesSecurity.integrations.read',
        'kubernetesSecurity.components.read',
      ],
      flags: ['ui__page-modules--organization-security__integrations'],
    },
    create: {
      groups: ['kubernetesSecurity.integrations.create'],
      flags: ['ui__page-modules--organization-security__integrations'],
    },
    update: {
      groups: ['kubernetesSecurity.integrations.write'],
      flags: ['ui__page-modules--organization-security__integrations'],
    },
    delete: {
      groups: ['kubernetesSecurity.integrations.delete'],
      flags: ['ui__page-modules--organization-security__integrations'],
    },
  },
  OrganizationSecurityWorkloads: {
    view: {
      groups: [
        'kubernetesSecurity.components.read',
        'kubernetesSecurity.compliance.read',
        'kubernetesSecurity.vulnerabilities.read',
      ],
      flags: ['ui__page-modules--organization-security__workloads'],
    },
  },
  OrganizationSecurityNodeRotation: {
    view: {
      groups: [
        'kubernetesSecurity.components.read',
        'kubernetesSecurity.vulnerabilities.read',
        'clusterOptimization.rebalancing.read',
        'clusterManagement.clusters.read',
        'clusterManagement.nodes.read',
      ],
      flags: ['ui__page-modules--organization-security__node-os-updates'],
    },
    create: {
      groups: ['clusterOptimization.rebalancing.create'],
      flags: ['ui__page-modules--organization-security__node-os-updates'],
    },
    update: {
      groups: ['clusterOptimization.rebalancing.write'],
      flags: ['ui__page-modules--organization-security__node-os-updates'],
    },
    delete: {
      groups: ['clusterOptimization.rebalancing.delete'],
      flags: ['ui__page-modules--organization-security__node-os-updates'],
    },
  },
  OrganizationAiOptimizerReports: {
    view: {
      groups: ['aiOptimizer.models.read'],
      flags: ['ui__page-modules--organization-llm__cost-report'],
    },
  },
  OrganizationAiOptimizerProviders: {
    view: {
      groups: ['aiOptimizer.providers.read'],
      flags: ['ui__page-modules--organization-llm__providers'],
    },
    create: {
      groups: ['aiOptimizer.providers.create'],
      flags: ['ui__page-modules--organization-llm__providers'],
    },
    update: {
      groups: ['aiOptimizer.providers.write'],
      flags: ['ui__page-modules--organization-llm__providers'],
    },
    delete: {
      groups: ['aiOptimizer.providers.delete'],
      flags: ['ui__page-modules--organization-llm__providers'],
    },
  },
  OrganizationAiOptimizerSettings: {
    view: {
      groups: ['aiOptimizer.settings.read'],
    },
    update: {
      groups: ['aiOptimizer.settings.write'],
    },
  },
  OrganizationAiOptimizerBatchJobs: {
    view: {
      groups: ['aiOptimizer.batchJobs.read'],
      flags: ['ui__page-modules--organization-llm__batch-jobs'],
    },
    update: {
      groups: ['aiOptimizer.batchJobs.write'],
      flags: ['ui__page-modules--organization-llm__batch-jobs'],
    },
  },
  OrganizationAiOptimizerPlayGround: {
    view: {
      groups: [
        'aiOptimizer.models.read',
        'aiOptimizer.events.read',
        'aiOptimizer.providers.read',
        'aiOptimizer.playgroundChatCompletions.read',
      ],
      flags: ['ui__page-modules--organization-llm__playground'],
    },
  },
  OrganizationAiOptimizerModelDeployments: {
    view: {
      groups: [
        'aiOptimizer.hostedModels.read',
        'aiOptimizer.components.read',
        'clusterManagement.clusters.read',
      ],
      flags: ['ui__page-modules--organization-llm__model-deployments'],
    },
    create: {
      groups: [
        'clusterManagement.clusters.read',
        'aiOptimizer.hostedModelSpecs.read',
        'clusterManagement.nodeConfigurations.read',
        'aiOptimizer.hostedModels.create',
      ],
      flags: ['ui__page-modules--organization-llm__model-deployments'],
    },
    update: {
      groups: [
        'aiOptimizer.hostedModels.write',
        'clusterManagement.clusters.write',
      ],
      flags: ['ui__page-modules--organization-llm__model-deployments'],
    },
    delete: {
      groups: ['aiOptimizer.hostedModels.delete'],
      flags: ['ui__page-modules--organization-llm__model-deployments'],
    },
  },
  OrganizationAiOptimizerSettingsPage: {
    view: {
      groups: [
        'aiOptimizer.settings.read',
        'aiOptimizer.components.read',
        'clusterManagement.clusters.read',
      ],
    },
    update: {
      groups: [
        'aiOptimizer.settings.write',
        'clusterManagement.clusters.write',
      ],
    },
  },
  OrganizationDbOptimizer: {
    view: {
      groups: [
        'databaseOptimizer.caches.read',
        'databaseOptimizer.clusters.read',
        'databaseOptimizer.components.read',
        'databaseOptimizer.instances.read',
        'databaseOptimizer.reports.read',
      ],
    },
    create: {
      groups: [
        'databaseOptimizer.caches.create',
        'databaseOptimizer.components.create',
      ],
    },
    update: {
      groups: [
        'databaseOptimizer.databases.write',
        'databaseOptimizer.caches.write',
        'databaseOptimizer.components.write',
      ],
    },
    delete: {
      groups: ['databaseOptimizer.caches.delete'],
    },
  },
  FeatureThemeSwitch: {
    view: {
      flags: ['ui__standalone--theme-switch'],
    },
  },
  FeatureOneClickPromotion: {
    view: {
      flags: ['ui__standalone--one-click__promotion'],
    },
  },
  OrganizationNetworkIntelligence: {
    view: {
      groups: ['kubernetesSecurity.runtime.read'],
    },
  },
  OrganizationBudgets: {
    view: {
      groups: ['costMonitoring.clusters.read'],
      flags: ['ui__page-modules--organization__cost-monitoring__budgets'],
    },
    create: {
      groups: ['costMonitoring.clusters.write'],
      flags: ['ui__page-modules--organization__cost-monitoring__budgets'],
    },
    update: {
      groups: ['costMonitoring.clusters.write'],
      flags: ['ui__page-modules--organization__cost-monitoring__budgets'],
    },
    delete: {
      groups: ['costMonitoring.clusters.write'],
      flags: ['ui__page-modules--organization__cost-monitoring__budgets'],
    },
  },
  OrganizationCustomDashboards: {
    view: {
      groups: ['costMonitoring.clusters.read', 'costMonitoring.workloads.read'],
      flags: [
        'ui__page-modules--organization__cost-monitoring__custom-dashboards',
      ],
    },
  },
  OrganizationManagement: {
    view: {
      groups: ['organizationManagement.organizations.read'],
      flags: ['ui__page-modules--organization-management'],
    },
    create: {
      groups: ['organizationManagement.organizations.create'],
      flags: ['ui__page-modules--organization-management'],
    },
    update: {
      groups: ['organizationManagement.organizations.write'],
      flags: ['ui__page-modules--organization-management'],
    },
    delete: {
      groups: ['organizationManagement.organizations.delete'],
      flags: ['ui__page-modules--organization-management'],
    },
  },
  OrganizationAccessManagement: {
    view: {
      groups: ['organizationManagement.iam.read'],
    },
    create: {
      groups: ['organizationManagement.iam.create'],
    },
    update: {
      groups: ['organizationManagement.iam.write'],
    },
    delete: {
      groups: ['organizationManagement.iam.delete'],
    },
  },
  OrganizationApaRunbooks: {
    view: {
      groups: [
        'applicationAutomation.runbooks.read',
        'applicationAutomation.components.read',
      ],
      flags: ['ui__page-modules--organization-apa__runbooks'],
    },
    create: {
      groups: [
        'applicationAutomation.runbooks.create',
        'clusterManagement.integrations.write',
      ],
      flags: ['ui__page-modules--organization-apa__runbooks'],
    },
    update: {
      groups: [
        'applicationAutomation.runbooks.write',
        'clusterManagement.integrations.write',
      ],
      flags: ['ui__page-modules--organization-apa__runbooks'],
    },
    delete: {
      groups: [
        'applicationAutomation.runbooks.delete',
        'clusterManagement.integrations.write',
      ],
      flags: ['ui__page-modules--organization-apa__runbooks'],
    },
  },
  OrganizationAuditLog: {
    view: {
      groups: ['organizationManagement.audit.read'],
      flags: ['ui__page-modules--organization__audit-log'],
    },
  },
  OrganizationSettings: {
    view: {
      groups: ['organizationManagement.settings.read'],
    },
    create: {
      groups: ['organizationManagement.settings.write'],
    },
    update: {
      groups: ['organizationManagement.settings.write'],
    },
    delete: {
      groups: ['organizationManagement.settings.write'],
    },
  },
  OrganizationCloudIntegrations: {
    view: {
      groups: ['inventoryManagement.cloudAssetIntegration.read'],
    },
    create: {
      groups: ['inventoryManagement.cloudAssetIntegration.create'],
    },
    update: {
      groups: ['inventoryManagement.cloudAssetIntegration.write'],
    },
    delete: {
      groups: ['inventoryManagement.cloudAssetIntegration.delete'],
    },
  },
  Clusters: {
    view: {
      groups: [
        'clusterManagement.clusters.read',
        'costMonitoring.workloads.read',
      ],
    },
    create: {
      groups: [
        'clusterManagement.clusters.create',
        'clusterManagement.clusters.write',
        'clusterOptimization.clusters.read',
      ],
    },
    update: {
      groups: ['clusterManagement.clusters.write'],
    },
    delete: {
      groups: ['clusterManagement.clusters.delete'],
    },
  },
  ClusterCostMonitoring: {
    view: {
      groups: [
        'costMonitoring.clusters.read',
        'costMonitoring.namespaces.read',
        'organizationManagement.billing.read',
        'costMonitoring.workloads.read',
        'costMonitoring.allocationGroups.read',
        'costMonitoring.nodes.read',
        'costMonitoring.nodeConfigurations.read',
      ],
      flags: ['ui__page-modules--cluster__cost-monitoring'],
    },
    create: {
      groups: ['costMonitoring.allocationGroups.create'],
      flags: ['ui__page-modules--cluster__cost-monitoring'],
    },
    update: {
      groups: [
        'costMonitoring.integrations.read',
        'costMonitoring.workloads.read',
        'costMonitoring.allocationGroups.write',
      ],
      flags: ['ui__page-modules--cluster__cost-monitoring'],
    },
    delete: {
      groups: ['costMonitoring.allocationGroups.delete'],
      flags: ['ui__page-modules--cluster__cost-monitoring'],
    },
  },
  ClusterScore: {
    view: {
      flags: ['ui__page-modules--cluster__cluster-score'],
    },
  },
  ClusterScoreRestrictions: {
    view: {
      flags: ['ui__page-modules--cluster__cluster-score-restrictions'],
    },
  },
  ClusterWorkloadAutoscaler: {
    view: {
      groups: [
        'workloadOptimization.workloads.read',
        'workloadOptimization.policies.read',
      ],
      flags: ['ui__page-modules--cluster__workload-optimization'],
    },
    create: {
      groups: ['workloadOptimization.workloads.write'],
    },
    update: {
      groups: [
        'workloadOptimization.policies.write',
        'workloadOptimization.workloads.write',
      ],
    },
    delete: {
      groups: ['workloadOptimization.policies.delete'],
    },
  },
  ClusterWorkloadHideHpa: {
    view: {
      flags: ['ui__page-modules--cluster__workload-optimization__hide-hpa'],
    },
  },
  ClusterWorkloadShowHpaV2: {
    view: {
      flags: ['ui__page-modules--cluster__workload-optimization__show-hpa-v2'],
    },
  },
  ClusterWorkloadHpaList: {
    view: {
      flags: ['ui__page-modules--cluster__workload-optimization__hpa-list'],
    },
  },
  ClusterWorkloadRequireWorkloadToggleConfirmation: {
    view: {
      flags: [
        'ui__page-modules--cluster__workload-optimization__require-workload-toggle-confirmation',
      ],
    },
  },
  ClusterWorkloadShowAutomatedColumnVPATable: {
    view: {
      flags: [
        'ui__page-modules--cluster__workload-optimization__show-automated-column-vpa-table',
      ],
    },
  },
  ClusterWorkloadImpact: {
    view: {
      flags: ['ui__page-modules--cluster__workload-optimization__impact'],
    },
  },
  ClusterWorkloadCustomMetrics: {
    view: {
      flags: [
        'ui__page-modules--cluster__workload-optimization__custom-metrics',
      ],
    },
    create: {
      groups: ['workloadOptimization.metrics.create'],
    },
    update: {
      groups: ['workloadOptimization.metrics.write'],
    },
    delete: {
      groups: ['workloadOptimization.metrics.delete'],
    },
  },
  ClusterWorkloadAutopilot: {
    view: {
      flags: ['ui__page-modules--cluster__workload-optimization__autopilot'],
    },
  },
  ClusterWorkloadGpuOptimization: {
    view: {
      flags: [
        'ui__page-modules--cluster__workload-optimization__gpu-optimization',
      ],
    },
  },
  ClusterNodes: {
    view: {
      groups: ['clusterManagement.nodes.read'],
      flags: ['ui__page-modules--cluster__node'],
    },
    create: {
      groups: ['clusterManagement.nodes.create'],
      flags: ['ui__page-modules--cluster__node'],
    },
    update: {
      groups: ['clusterManagement.nodes.write'],
      flags: ['ui__page-modules--cluster__node'],
    },
    delete: {
      groups: ['clusterManagement.nodes.delete'],
      flags: ['ui__page-modules--cluster__node'],
    },
  },
  ClusterAutoscaler: {
    view: {
      groups: [
        'clusterOptimization.evictor.read',
        'clusterManagement.clusterPolicies.read',
        'clusterManagement.nodeConfigurations.read',
        'clusterManagement.nodes.read',
        'clusterOptimization.settings.read',
      ],
      flags: ['ui__page-modules--cluster__autoscaler__settings'],
    },
    create: {
      groups: ['clusterManagement.nodeConfigurations.create'],
      flags: ['ui__page-modules--cluster__autoscaler__settings'],
    },
    update: {
      groups: [
        'clusterOptimization.evictor.write',
        'clusterManagement.clusterPolicies.write',
        'clusterManagement.nodeConfigurations.write',
      ],
      flags: ['ui__page-modules--cluster__autoscaler__settings'],
    },
    delete: {
      groups: ['clusterManagement.nodeConfigurations.delete'],
      flags: ['ui__page-modules--cluster__autoscaler__settings'],
    },
  },
  ClusterPodMutations: {
    view: {
      groups: [
        'clusterManagement.clusterPolicies.read',
        'clusterManagement.nodeConfigurations.read',
        'clusterOptimization.settings.read',
        'clusterManagement.podMutation.read',
      ],
    },
    create: {
      groups: ['clusterManagement.podMutation.create'],
    },
    update: {
      groups: ['clusterManagement.podMutation.write'],
    },
    delete: {
      groups: ['clusterManagement.podMutation.delete'],
    },
  },
  ClusterEdgeLocations: {
    view: {
      groups: [
        'edgeManagement.clusters.read',
        'edgeManagement.edgeConfigurations.read',
        'edgeManagement.edgeLocations.read',
        'edgeManagement.edges.read',
        'edgeManagement.operations.read',
      ],
    },
    create: {
      groups: [
        'edgeManagement.edgeLocations.create',
        'edgeManagement.edges.create',
      ],
    },
    update: {
      groups: [
        'edgeManagement.clusters.write',
        'edgeManagement.edgeLocations.write',
        'edgeManagement.edges.write',
      ],
    },
    delete: {
      groups: [
        'edgeManagement.edgeLocations.delete',
        'edgeManagement.edges.delete',
      ],
    },
  },
  ClusterRebalancer: {
    view: {
      groups: [
        'clusterOptimization.rebalancing.read',
        'clusterOptimization.workloads.read',
      ],
      flags: ['ui__page-modules--cluster__rebalancer'],
    },
    create: {
      groups: ['clusterOptimization.rebalancing.create'],
      flags: ['ui__page-modules--cluster__rebalancer'],
    },
    update: {
      groups: ['clusterOptimization.rebalancing.write'],
      flags: ['ui__page-modules--cluster__rebalancer'],
    },
    delete: {
      groups: ['clusterOptimization.rebalancing.delete'],
      flags: ['ui__page-modules--cluster__rebalancer'],
    },
  },
  ClusterAuditLog: {
    view: {
      groups: ['organizationManagement.audit.read'],
      flags: ['ui__page-modules--cluster__audit-log'],
    },
  },
  ComponentControl: {
    update: {
      groups: ['organizationManagement.components.write'],
    },
  },
  EnterpriseManagement: {
    view: {
      groups: ['enterpriseOrganizationManagement.enterprise.read'],
    },
    create: {
      groups: ['enterpriseOrganizationManagement.enterprise.create'],
    },
    update: {
      groups: ['enterpriseOrganizationManagement.enterprise.write'],
    },
    delete: {
      groups: ['enterpriseOrganizationManagement.enterprise.delete'],
    },
  },
  ClusterKentKarpenterSettings: {
    view: {
      groups: ['kent.nodePools.read', 'kent.nodeClasses.read'],
    },
  },
  ClusterKentFeatures: {
    view: {
      groups: ['kent.features.read'],
    },
    update: {
      groups: ['kent.features.write'],
    },
  },

  FeatureGoogleOptimize: {
    view: {
      flags: ['ui__external-features--google-optimize'],
    },
  },
  FeatureGoogleTagManager: {
    view: {
      flags: ['ui__external-features--google-tag-manager'],
    },
  },
  FeatureHubspot: {
    view: {
      flags: ['ui__external-features--hubspot'],
    },
  },
  FeatureSentry: {
    view: {
      flags: ['ui__external-features--sentry'],
    },
  },
  FeatureClusterCostMonitoringBlurOptimizedNodes: {
    view: {
      flags: ['ui__standalone--available-savings-blur-optimized-nodes'],
    },
  },
  FeatureClusterCostMonitoringShortDateRange: {
    view: {
      flags: ['ui__standalone--cost-monitoring-short-date-range'],
    },
  },
  FeatureClusterCostMonitoringPhase1Recommendations: {
    view: {
      flags: [
        'ui__page-modules--cluster__cost-report__workload__efficiency__phase1-recommendations',
      ],
    },
  },
  FeatureClusterAutoscalerSwitch: {
    view: {
      flags: ['ui__standalone--autoscaler-switch'],
    },
  },
  FeatureClusterCostMonitoringSavingsPercentages: {
    view: {
      flags: ['ui__standalone--cost-monitoring__show-savings_percentages'],
    },
  },
  FeatureOrganizationManagementRoleBindings: {
    view: {
      flags: ['ui__page-modules--organization-management-role-bindings'],
    },
  },
  FeatureOrganizationManagementComponentControl: {
    view: {
      flags: ['ui__page-modules--component-control'],
    },
  },
  FeatureOrganizationManagementFeatureControl: {
    view: {
      flags: ['ui__page-modules--organization-management-feature-control'],
    },
  },
  FeatureClusterCostMonitoringPotentialSavings: {
    view: {
      flags: ['ui__page-modules--cluster__potential-savings'],
    },
  },
  FeatureReliabilityMetricsAvailableInBeta: {
    view: {
      flags: ['ui__standalone--reliability-metrics-available-in-beta'],
    },
  },
  FeatureModelAutoscaler: {
    view: {
      flags: ['ui__standalone--model-autoscaler'],
    },
  },
  FeatureClusterAutoscalerGeneratedNodeTemplates: {
    view: {
      flags: ['ui__standalone--autoscaler-view-generated-node-templates'],
    },
  },
  FeatureSecurityCastAnywhere: {
    view: {
      flags: ['ui__standalone--security-cast-anywhere'],
    },
  },
  FeaturePricingHideDiscounts: {
    view: {
      flags: ['ui__standalone--pricing__hide-discounts'],
    },
  },
  FeatureRebalancerRework: {
    view: {
      flags: ['ui__standalone--rebalancer-rework'],
    },
  },
  FeatureRebalancingBatchMode: {
    view: {
      flags: ['ui__standalone--rebalancing-batch-mode'],
    },
  },
  FeatureCostReportAIAssistant: {
    view: {
      flags: ['ui__standalone--cost-report-ai-assistant'],
    },
  },
  FeatureCastwareOperator: {
    view: {
      flags: ['ui__standalone--operator-castware'],
    },
  },
  FeatureOnlyClusterProviderEdges: {
    view: {
      flags: ['ui__standalone--only-cluster-provider-edges'],
    },
  },
  FeatureCastwareCastaiAgent: {
    view: {
      flags: ['ui__standalone--castai-agent-castware'],
    },
  },
  FeatureCastwareEvictor: {
    view: {
      flags: ['ui__standalone--evictor-castware'],
    },
  },
  FeatureCastwareSpotHandler: {
    view: {
      flags: ['ui__standalone--spot-handler-castware'],
    },
  },
  FeatureCastwareClusterController: {
    view: {
      flags: ['ui__standalone--cluster-controller-castware'],
    },
  },
  FeatureCastwarePodMutator: {
    view: {
      flags: ['ui__standalone--pod-mutator-castware'],
    },
  },
  FeatureCastwarePodPinner: {
    view: {
      flags: ['ui__standalone--pod-pinner-castware'],
    },
  },
  FeatureCastwareCastaiGpuMetricsExporter: {
    view: {
      flags: ['ui__standalone--castai-gpu-metrics-exporter-castware'],
    },
  },
  FeatureCastwareAuditLogsReceiver: {
    view: {
      flags: ['ui__standalone--audit-logs-receiver-castware'],
    },
  },
  FeatureCastwareWorkloadAutoscaler: {
    view: {
      flags: ['ui__standalone--workload-autoscaler-castware'],
    },
  },
  FeatureCastwareKvisor: {
    view: {
      flags: ['ui__standalone--kvisor-castware'],
    },
  },
  FeatureCastwareEgressdExporter: {
    view: {
      flags: ['ui__standalone--egressd-exporter-castware'],
    },
  },
  FeatureCastwareAiOptimizerProxy: {
    view: {
      flags: ['ui__standalone--ai-optimizer-proxy-castware'],
    },
  },
  FeatureCastwareDbOptimizer: {
    view: {
      flags: ['ui__standalone--db-optimizer-castware'],
    },
  },
  FeatureCastwareOmni: {
    view: {
      flags: ['ui__standalone--omni-castware'],
    },
  },
  FeatureCastwareLiveController: {
    view: {
      flags: ['ui__standalone--live-controller-castware'],
    },
  },
  FeatureHideAvailableSavingsPhase1OptimalClusterBanner: {
    view: {
      flags: [
        'ui__standalone--available-savings-hide-phase1-optimal-cluster-banner',
      ],
    },
  },
  FeatureSecurityVulnerabilitiesOverviewTab: {
    view: {
      flags: ['ui__standalone--sec-vulnerabilities-overview-tab'],
    },
  },
  AlertContractEnding: {
    view: {
      flags: ['ui__standalone--ending-contract'],
    },
  },
  FeatureOmniAvailableRegions: {
    view: {
      flags: ['ui__standalone--omni-available-regions'],
    },
  },
  FeatureWoopResourceQuotaCorrectionEnabled: {
    view: {
      flags: [
        'ui__page-modules--cluster__workload-optimization__woop-resource-quota-correction-enabled',
      ],
    },
  },
  FeatureWoopMemoryGrowthDetectionEnabled: {
    view: {
      flags: [
        'ui__page-modules--cluster__workload-optimization__woop-memory-growth-detection-enabled',
      ],
    },
  },
  FeatureAIEServerlessModelsNotification: {
    view: {
      flags: ['ui__standalone--aie-serverless-models-notification'],
    },
  },
  FeatureAIEStripePaymentFlow: {
    view: {
      flags: ['ui__standalone--aie-stripe-payment-flow'],
    },
  },
  OrganizationAiOptimizerServerless: {
    view: {
      groups: ['aiOptimizer.models.read'],
      flags: ['ui__page-modules--ai-enabler__serverless'],
    },
  },
  FeatureAiOptimizerSurvey: {
    view: {
      flags: ['ui__standalone--ai-optimizer-survey'],
    },
  },
  FeatureAiOptimizerRoutingTab: {
    view: {
      flags: ['ui__standalone--ai-optimizer-routing-tab'],
    },
  },
  FeatureAzureSavingsPlans: {
    view: {
      flags: ['ui__standalone--aks-savings-plans'],
    },
  },
  FeatureClusterContainerLiveMigration: {
    view: {
      flags: ['ui__page-modules--automation__cluster-container-live-migration'],
    },
  },
  FeatureSecuritySunset: {
    view: {
      flags: ['ui__standalone--security-sunset'],
    },
  },
  FeatureClusterSpotInterruptions: {
    view: {
      flags: ['ui__page-modules--automation__cluster-spot-interruptions'],
    },
  },
  ClusterNodeAutoscalerStop: {
    view: {
      flags: ['ui__page-modules--cluster__autoscaler__stop'],
    },
  },
  ClusterStopPersistentVolumes: {
    view: {
      flags: ['ui__page-modules--cluster__stop__persistent-volumes'],
    },
  },
  ClusterStopConfig: {
    view: {
      flags: ['ui__page-modules--cluster__stop__config'],
    },
  },
  ClusterStopPvPolicies: {
    view: {
      groups: ['storageOptimization.persistentVolumePolicies.read'],
      flags: ['ui__page-modules--cluster__stop__pv-policies'],
    },
    update: {
      groups: ['storageOptimization.persistentVolumePolicies.write'],
      flags: ['ui__page-modules--cluster__stop__pv-policies'],
    },
  },
  ClusterStopEvents: {
    view: {
      flags: ['ui__page-modules--cluster__stop__events'],
    },
  },
  ClusterAutomationNewDashboard: {
    view: {
      flags: ['ui__page-modules--automation__new-dashboard'],
    },
  },
  FeatureCommitmentsDisableAllAssignmentsFetching: {
    view: {
      flags: ['ui__standalone--commitments-disable-all-assignments-fetching'],
    },
  },
  FeatureNetworkIntelligenceServiceMapV2: {
    view: {
      flags: ['ui__standalone--network-intelligence-service-map-v2'],
    },
  },
  FeatureNotificationsCatalogue: {
    view: {
      flags: ['ui__standalone--notifications-catalogue'],
    },
  },
  ClusterEdgeConfigurations: {
    view: {
      groups: ['edgeManagement.edgeConfigurations.read'],
    },
    create: {
      groups: ['edgeManagement.edgeLocations.create'],
    },
    update: {
      groups: ['edgeManagement.edgeLocations.write'],
    },
    delete: {
      groups: ['edgeManagement.edgeLocations.delete'],
    },
  },
  FeatureGpuMetrics: {
    view: {
      flags: ['ui__standalone--cost-monitoring__show-gpu-metrics'],
    },
  },
  FeatureSsoSaml: {
    view: {
      flags: ['ui__standalone--sso-saml'],
    },
  },
  FeatureDboV2: {
    view: {
      flags: ['ui__standalone--dbo-v2'],
    },
  },
  /**
   * Upstream query errors page (POLY-2202) — hidden until the real API
   * ships; enable `ui__standalone--dbo-query-errors` per environment.
   */
  FeatureDboQueryErrors: {
    view: {
      flags: ['ui__standalone--dbo-query-errors'],
    },
  },
  FeatureUserGroupNamespaceLabelMapping: {
    view: {
      flags: ['ui__standalone--user-group-namespace-label-mapping'],
    },
  },
  FeatureOptimizationConstraintsSilencing: {
    view: {
      flags: ['ui__standalone--optimization-constraints-silencing'],
    },
  },
};
